import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom, PrimitiveAtom } from 'jotai';
import { ExpandKeywordInfo } from 'shared/models';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleRelatedExperience {
  answerReferralQuery: ExpandKeywordInfo[];
}

type ArticleRelatedExperienceStore = { [key: string]: Promise<IArticleRelatedExperience> | undefined };

const $ArticleRelatedExperienceStore: PrimitiveAtom<ArticleRelatedExperienceStore> =
  atom<ArticleRelatedExperienceStore>({});

export const $ArticleRelatedExperience = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleRelatedExperienceStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        return Unreachable(`no data for GPTAnswer: ${groupId}`);
      }
      return data;
    },
    (get, set, args: any) => {
      const old = get($ArticleRelatedExperienceStore);
      set($ArticleRelatedExperienceStore, { ...old, [groupId]: args });
    },
  );

  a.debugLabel = `$ArticleRelatedExperience+${encodeURIComponent(groupId)}`;

  return a;
});
